import React from 'react';
import {WeaLocaleProvider} from 'ecCom';
import {Calendar} from 'antd';
import {WeaTextarea} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header';
import './css/index';

export default class Content_calendar extends React.Component {
    render() {
        const {data = {}, config ={}, eid} = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header data={data} eid={eid}/>
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div id={`scratchpad__${eid}`}>
                            <WeaTextarea
                                id={`scratchpadarea_${eid}`}
                                minRows={10}
                                value={getLabel(501225,'随时记录你的idea') }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_scratchpad.js